<template>
  <div class="direct_baseInfo">
    <el-form
      ref="baseInfoForm"
      :model="baseInfoForm"
      label-width="180px"
      class="form baseInfo_form"
      :rules="baseInfoRules"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>抽取基本信息</span>
        </div>
        <div v-if="canEditpage">
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="任务名称：" prop="workName">
                <el-input
                  type="textarea"
                  :rows="1"
                  placeholder="请输入任务名称"
                  v-model="baseInfoForm.workName"
                  :maxlength="600"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <!-- 备案时只读· -->
              <el-form-item label="抽取编号：" prop="extractCode">
                <el-input
                  type="textarea"
                  :rows="1"
                  placeholder="请输入抽取编号"
                  v-model="baseInfoForm.extractCode"
                  :maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="抽取类别：">
                <el-input v-model="baseInfoForm.extractTypeName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="监督检查单位：" prop="supervisionIds" style="width:100%;">
                <!-- <el-select
                  v-model="baseInfoForm.supervisionIds"
                  :popper-append-to-body="true"
                  filterable
                  multiple
                  clearable
                  value-key="id"
                  style="width:100%;"
                >
                  <el-option
                    v-for="(item,index) in orgSelectList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select> -->
                <select-depart-tree 
                ref="selectDepartTreeRef"
                :modelValue.sync="baseInfoForm.supervisionIds"  
                :isMultiple="true" 
                @handleDeptType="(val)=>changeDept(val,'5')" >
               </select-depart-tree>
              </el-form-item>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="抽取完成时间：" prop="extractTime">
                <el-date-picker v-model="baseInfoForm.extractTime" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="抽取人员：" prop="extractorName">
                <el-input v-model="baseInfoForm.extractorName" placeholder="请输入抽取人员"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="!canEditpage">
          <el-row>
            <el-col :span="24">
              <el-form-item label="任务名称：">
                <span>{{ baseInfoForm.workName || "-" }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="抽取编号：">
                <span>{{ baseInfoForm.extractCode || "-" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="抽取类型：">
                <span>{{ baseInfoForm.extractTypeName || "-" }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="监督检查单位：">
                <span>{{ baseInfoForm.supervisionIdsName || "-" }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="抽取完成时间：">
                <span>{{ baseInfoForm.extractTime || "-" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="抽取人员：">
                <span>{{ baseInfoForm.extractorName || '-'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import selectDepartTree from "@/views/modules/components/selectDepartTree"

export default {
  props: {
    formData:{
      type: Object,
      default: () => {}
    }
  },
  components: {
            selectDepartTree
        },
  data() {
    return {
      canEditpage: true,
      orgSelectList: [], // 监督检查单位列表
      baseInfoForm: {
        workName: "",
        extractCode: "",
        extractType:null, // 默认值
        extractTypeName: "招投标项目", // 默认值
        supervisionIdsName: "",
        extractTime: "",
        extractorName: "",
        supervisionIds: []
      },
      baseInfoRules: {
        workName: [
          { required: true, message: "请输入任务名称", trigger: "blur" }
        ],
        extractCode: [
          { required: true, message: "请输入抽取编号", trigger: "blur" }
        ],
        supervisionIds: [
          {
            required: true,
            message: "请选择监督检查单位",
            trigger: ["blur", "change"]
          }
        ],
        extractTime: [
          { required: true, message: "请选择抽取完成时间", trigger: "blur" }
        ],
        extractorName: [
          { required: true, message: "请输入抽取人员", trigger: "blur" }
        ]
      }
    };
  },
  watch:{
    formData: {
      deep: true,
      immediate: true,
      handler(newV, oldV) {
        this.baseInfoForm= JSON.parse(JSON.stringify(newV));
        this.canEditpage=newV.canEdit
      }
    },
    baseInfoForm:{
      deep: true,
      immediate: true,
      handler(newV, oldV) {
     this.$emit("changebaseInfoFormMethods",newV)
      }
    }

  },
  mounted() {
    //监督检查单位选项获取
    this.getOrgSelectList();
    this.$nextTick(()=>{
      this.$refs.baseInfoForm.clearValidate('supervisionIds');
    })  
  },
  methods: {
    changeDept(val,flag){
                this.baseInfoForm.supervisionIds=[]
                if(flag=='5'){
                    val.forEach((item)=>{
                        if( item.type!=="region"){
                        this.baseInfoForm.supervisionIds.push(item.id)}
                    })
                }
        },
    validate(callback) {
      //这个form是子组件内部 el-form 的 ref="baseInfoForm"
      this.$refs.baseInfoForm.validate(valid => {
        callback(valid);
      });
    },
    // 监督检查单位已选择的值获取
    getDeptInfo() {
      this.$httpReq.get("/configs/sysexectormanage/listUserOrg").then(res => {
        if (
          res.data.code == "1" &&
          res.data.data &&
          res.data.data.length > 0 &&
          this.baseInfoForm.supervisionIds.length == 0
        ) {
          let resData = res.data.data || [];
          const _this = this;
          resData.forEach(item => {
            if (item.isMaster && item.orgId)
              _this.baseInfoForm.supervisionIds.push(item.deptId);
          });
        }
      });
    },
    getOrgSelectList() {
      this.$httpReq
        .get("/projectDoubleExtract/extracttask/getDepartments")
        .then(res => {
          if (res.data.code == "1") {
            let resData = res.data.data || [];
            let dataArr = [];
            resData.forEach(item => {
              dataArr.push(item.data);
            });
            this.orgSelectList = dataArr;
            return;
          }
        });
    }
  }
};
</script>
  <style lang="scss" scoped>
</style>